var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#F22458"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 4.125C4.25 4.125 3.25 5.25 3.25 6.875C3.25 9.45244 5.35149 11.0344 6.75888 11.8049C7.24521 12.0712 7.48837 12.2043 8 12.2043C8.51163 12.2043 8.75479 12.0712 9.24112 11.8049C10.6485 11.0344 12.75 9.45244 12.75 6.875C12.75 5.25 11.75 4.125 10.25 4.125C9.25326 4.125 8.63275 4.64233 8.30194 5.04234C8.13987 5.23831 8.05883 5.3363 8 5.3363C7.94117 5.3363 7.86013 5.23831 7.69806 5.04234C7.36725 4.64232 6.74674 4.125 5.75 4.125Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.9116af56.svg";
export { ForwardRef as ReactComponent };